import React, { useState } from 'react';
import StoreModal from '../components/StoreModal';
import './Services.css';

const services = [
  { icon: '⚡', title: 'Electricians', desc: 'Wiring, installations, repairs, and electrical inspections by certified professionals.', count: '1,200+' },
  { icon: '🔧', title: 'Plumbers', desc: 'Pipe repairs, installations, water heaters, and drainage solutions.', count: '900+' },
  { icon: '🪚', title: 'Carpenters', desc: 'Custom furniture, repairs, roofing, and all woodwork needs.', count: '750+' },
  { icon: '🧹', title: 'Cleaners', desc: 'Home, office, and deep cleaning services for any space.', count: '1,800+' },
  { icon: '📚', title: 'Tutors', desc: 'Expert tutors for all subjects, ages, and learning styles.', count: '600+' },
  { icon: '🎨', title: 'Painters', desc: 'Interior and exterior painting, wallpaper, and surface preparation.', count: '500+' },
  { icon: '🏗️', title: 'Builders', desc: 'Construction, masonry, renovations, and structural work.', count: '400+' },
  { icon: '🌿', title: 'Landscapers', desc: 'Garden design, lawn care, pruning, and outdoor maintenance.', count: '350+' },
  { icon: '🖥️', title: 'IT Technicians', desc: 'Computer repairs, networking, software setup, and tech support.', count: '700+' },
  { icon: '📸', title: 'Photographers', desc: 'Events, portraits, real estate, and commercial photography.', count: '450+' },
  { icon: '🚚', title: 'Movers', desc: 'Residential and commercial moving services, packing included.', count: '300+' },
  { icon: '💆', title: 'Wellness', desc: 'Massage therapists, beauticians, and personal care professionals.', count: '550+' },
];

export default function Services() {
  const [search, setSearch] = useState('');
  const [storeModal, setStoreModal] = useState(false);

  const filtered = services.filter(s =>
    s.title.toLowerCase().includes(search.toLowerCase()) ||
    s.desc.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="page services-page">
      <section className="services-hero">
        <div className="container">
          <span className="section-label">What We Offer</span>
          <h1 className="section-title">Professional Services for Every Need</h1>
          <p className="section-desc">From home repairs to personal tutoring, AfreXpert connects you with verified experts across dozens of categories.</p>
          <div className="services-search">
            <span className="search-icon">🔍</span>
            <input
              type="text"
              placeholder="Search services..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
        </div>
      </section>

      <section className="services-grid-section">
        <div className="container">
          {filtered.length === 0 ? (
            <div className="no-results">
              <span>🔎</span>
              <p>No services found for "<strong>{search}</strong>"</p>
              <button onClick={() => setSearch('')}>Clear Search</button>
            </div>
          ) : (
            <div className="services-grid">
              {filtered.map((s, i) => (
                <div key={i} className="service-card" style={{ animationDelay: `${i * 0.05}s` }}>
                  <div className="service-top">
                    <div className="service-icon">{s.icon}</div>
                    <span className="service-count">{s.count} pros</span>
                  </div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <div className="service-cta">
                    <button className="service-link" onClick={() => setStoreModal(true)}>
                      Book Now →
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="services-bottom-cta">
        <div className="container">
          <div className="bottom-cta-card">
            <span className="cta-emoji">🚀</span>
            <h2>Don't see your service?</h2>
            <p>We're growing fast. Request a new category or post a custom job on the app.</p>
            <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="btn-primary" onClick={() => setStoreModal(true)}>Download App</button>
            </div>
          </div>
        </div>
      </section>

      {storeModal && <StoreModal onClose={() => setStoreModal(false)} />}
    </div>
  );
}
